import { Controller } from "@hotwired/stimulus";

export default class ClipboardController extends Controller {
  static targets = ["source", "button"];

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      this.showCopied();
    });
  }

  showCopied() {
    const originalHTML = this.buttonTarget.innerHTML;

    // Show checkmark and "Copied!" text
    this.buttonTarget.innerHTML = `
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <span>Copied!</span>
    `;

    // Revert after 2 seconds
    setTimeout(() => {
      this.buttonTarget.innerHTML = originalHTML;
    }, 2000);
  }
}
